import { unstable_cache } from 'next/cache';

import type { ContentStackEntryDataProps } from '@/types/contentStack';
import type {
    ContentTypeProps,
    LocaleProps,
} from '@nxt-costco-com/forge-digital-components';

import { getConfigurationSettingByDeveloperKey } from './getConfigurationSettingByDeveloperKey';

/**
 * Convenience method which directly returns the contents of the JSON property in a config entry
 */
export const _getConfigurationPropertiesByDeveloperKey = async <T>(
    contentType: ContentTypeProps,
    developmentKey: string,
    locale: LocaleProps,
    enableLivePreview = false,
) => {
    const config: ContentStackEntryDataProps<T> =
        await getConfigurationSettingByDeveloperKey(
            contentType,
            developmentKey,
            locale,
            enableLivePreview,
        );

    if (!config || !config.properties || !config.properties?.[0]) {
        return null;
    }

    return config.properties.shift();
};

const cached_getConfigurationPropertiesByDeveloperKey = unstable_cache(
    _getConfigurationPropertiesByDeveloperKey,
    ['search_getConfigurationPropertiesByDeveloperKey'],
    { revalidate: 1800 },
);

export const getConfigurationPropertiesByDeveloperKey = async (
    contentType: ContentTypeProps,
    developmentKey: string,
    locale: LocaleProps,
    enableLivePreview = false,
) => {
    const fn =
        typeof window === 'undefined'
            ? cached_getConfigurationPropertiesByDeveloperKey
            : _getConfigurationPropertiesByDeveloperKey;

    return fn(contentType, developmentKey, locale, enableLivePreview);
};
